<template>
    <div class="
        grid grid-cols-12 col-span-4 col-start-1 mt-20 mb-10 gap-y-16
        sm:col-span-12 sm:gap-x-4 sm:gap-y-24
        md:gap-x-6 md:mb-0 md:gap-y-32
        lg:gap-x-[30px] lg:mb-10
        xxl:mb-24 xxl:mt-36 xxl:gap-x-10 xxl:gap-y-28
    ">
        <a class="
            fade-in flex flex-col col-span-12 border-cream border-b pb-12
            sm:col-span-4 sm:border-0 sm:pb-0 
        "
            :href="post.link"
            v-for="post in posts"
            :key="post.id"
            :id="post.slug"
        >
            <div class="relative w-full overflow-hidden mb-8 sm:mb-3.5 md:mb-4 lg:mb-5 xxl:mb-8 rounded-[14px]">
                <div class="pb-[65%]"></div>
                <img class="absolute left-0 top-0 w-full h-full object-cover object-center" :src="post.image.sizes.large" :alt="post.image.alt" v-if="post.image">
            </div>

            <div class="flex flex-wrap">
                <div 
                    class="text-center text-14 uppercase py-2 mb-8 mr-2" 
                    :class="{'bg-lightGreen rounded-full px-8' : type.slug === 'dojo', 'bg-blue px-4' : type.slug !== 'dojo'}"
                    v-for="type in post.types"
                    :key="type.id"
                    v-html="type.name"
                ></div>
            </div>

            <h4 class="
                text-30 mb-8
                sm:text-16 sm:leading-1.125 sm:mb-3.5
                md:mb-4
                lg:text-25 lg:leading-1.2 lg:mb-5
                xxl:text-30 xxl:leading-1.25 xxl:mb-9"
                v-html="post.title">
            </h4>

            <p class="text-20 sm:text-13 lg:text-16 xxl:text-base" v-html="post.date"></p>
        </a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoaded: false,
        }
    },

    props: {
        posts: Array,
    },

    mounted() {
        this.isLoaded = true;
    },

    methods: {
        
    },
}
</script>

<style scoped lang="scss">
    .fade-in {
        animation: fade-in .67s ease;
    }
    
    @keyframes fade-in {
        from {
            @apply opacity-0;
        }
        to {
            @apply opacity-100
        }
    }
</style>